'use client';

import Image from 'next/image';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/navigation';
import { FacetsViewModel } from '@/types/api';
import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants';
import { Button } from '@/features/button';
import { STOCK_FACET_KEY } from '@/features/filter/constants';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import { PLPPages } from '@/app/(plp)/types';
import { getCdnUrl } from '@/utils/url';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
export const NoResults = () => {
  const {
    isMobile
  } = useMobileDetect();
  const pathname = usePathname();
  const {
    deactivateFacets,
    allFacets,
    setOnlyInStock,
    page
  } = usePLPFacetsContext();
  const searchParams = useSearchParams();
  const router = useRouter();
  const searchQuery = searchParams.get(PRODUCT_QUERY_PARAMS.SEARCH);
  const isAnyFilterApplied = !!searchParams.toString();
  const showRemoveFiltersButton = isAnyFilterApplied && (page !== PLPPages.Search || page === PLPPages.Search && [...searchParams.keys()].some(key => key !== PRODUCT_QUERY_PARAMS.SEARCH));
  const noProduct = !isAnyFilterApplied && page !== PLPPages.Search;
  const onClearAllFilters = () => {
    if (!allFacets) {
      const redirectUrl = page === PLPPages.Search ? `/${page}?${PRODUCT_QUERY_PARAMS.SEARCH}=${searchQuery}` : pathname;
      setOnlyInStock?.(false);
      router.push(redirectUrl);
      router.refresh();
      return;
    }
    const keys = [...Object.keys(allFacets), STOCK_FACET_KEY];
    deactivateFacets?.(keys as (keyof FacetsViewModel)[]);
  };
  const NoProductSearch = getCdnUrl('/_toad/images/no-product-search.svg');
  const NoProductFilter = getCdnUrl('/_toad/images/no-product-filter.svg');
  const NoProductAvailable = getCdnUrl('/_toad/images/no-product.svg');
  return <div className='flex grow flex-col items-center justify-center overflow-hidden lg:relative lg:min-h-[calc(100dvh_-_246px)] lg:grow-0' data-sentry-component="NoResults" data-sentry-source-file="no-results.tsx">
            <div className='flex grow flex-col items-center justify-center lg:grow-0'>
                <Image
      // eslint-disable-next-line no-nested-ternary
      src={noProduct ? NoProductAvailable : showRemoveFiltersButton ? NoProductFilter : NoProductSearch} width={250} height={200} unoptimized className='mb-4' alt='تصویر جست‌وجوی بدون نتیجه' data-sentry-element="Image" data-sentry-source-file="no-results.tsx" />
                <p className='text-center text-body-14 text-text-darkGray lg:text-body-16'>
                    {/* eslint-disable-next-line no-nested-ternary */}
                    {noProduct ? 'فعلا محصولی برای نمایش نداریم!' : showRemoveFiltersButton ? 'محصولی با فیلترهایی که انتخاب کرده‌اید یافته نشد!' : <>
                            برای جست‌وجوی شما نتیجه‌ای یافته نشد!
                            <br />
                            پیشنهاد می‌کنیم عبارت‌های مشابه را جست‌وجو کنید.
                        </>}
                </p>
            </div>

            {(!allFacets || isMobile) && <div className='flex min-h-[76px] w-screen items-center px-4 lg:mt-3 lg:w-fit'>
                    <Button className='w-full' graphicStyle='outlined' size='medium' onClick={showRemoveFiltersButton ? onClearAllFilters : () => router.push('/')}>
                        {showRemoveFiltersButton ? 'حذف فیلتر ها' : 'خانه'}
                    </Button>
                </div>}
        </div>;
};